import { observer } from 'mobx-react-lite'
import { EmptyState, Typography } from 'shared/ui'
import { LINK_CUSTOM_SHORT_URL } from 'shared/constants/links'
import {
  AddDomainButton,
  GuideButton,
} from 'pages/settings/pages/urlShortener/ui/UrlShortenerAction/UrlShortenerAction'
import styles from './styles.module.scss'

export const UrlShortenerEmpty = observer(() => {
  return (
    <section className={styles.empty}>
      <EmptyState
        title={
          <span className={styles.title}>
            <div className={styles.video}>
              <iframe
                src='https://www.youtube.com/embed/7TCOwyFiwMM?si=mCtQbR3CxvbIItJT&amp;controls=1'
                width='628'
                height='352'
                title='YouTube video player'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;'
                referrerPolicy='strict-origin-when-cross-origin'
                allowFullScreen
              />
            </div>
            <Typography variant={'heading-lg'} ariaLabel=' Create branded short links'>
              Create branded short links
            </Typography>
          </span>
        }
        actions={
          <div className={styles.actions}>
            <AddDomainButton className={styles.actionButton} />
            <GuideButton className={styles.actionButton} />
          </div>
        }
        text={
          <>
            Shorten links with your own custom domain to boost brand trust and click-throughs.{' '}
            <Typography key={'link'} variant={'body-lg-regular'} linkLight ariaLabel={'LearnMore'}>
              <a href={LINK_CUSTOM_SHORT_URL} target={'_blank'} rel='noreferrer'>
                Learn more
              </a>
            </Typography>
          </>
        }
        typographyProps={{
          variant: 'body-lg-regular',
          ariaLabel: 'TagsText',
          marginTop: '4px',
        }}
        boxProps={{
          gap: '20px',
          width: 'unset',
          height: 'unset',
          textAlign: 'center',
        }}
        noIcon
      />
    </section>
  )
})
